// Constants for different requests for current reducer
export default {
  activityIR: 'ACTIVITY_IR',
};
